import { useContext, useEffect, useState } from 'react';

import { LastLocationContext } from '../contexts/lastLocation';

export function useLastRoute(fallback) {
  const lastLocation = useContext(LastLocationContext);
  const [lastRoute, setLastRoute] = useState();

  useEffect(
    function effect() {
      if (!lastRoute && !!lastLocation) {
        setLastRoute(lastLocation);
      }
    },
    [lastLocation],
  );

  return lastRoute || fallback;
}
